export default function getSepaEnabledBankCountries(): string[] {
  // reimplementation of [API] src/constants/country_codes.js
  return [
    'at', // [eur] austria
    'be', // [eur] belgium
    'hr', // [eur] croatia
    'cy', // [eur] cyprus
    'ee', // [eur] estonia
    'fi', // [eur] finland
    'fr', // [eur] france
    'de', // [eur] germany
    'gr', // [eur] greece
    'ie', // [eur] ireland
    'it', // [eur] italy
    'lv', // [eur] latvia
    'lt', // [eur] lithuania
    'lu', // [eur] luxembourg
    'mt', // [eur] malta
    'nl', // [eur] netherlands
    'pt', // [eur] portugal
    'sk', // [eur] slovakia
    'si', // [eur] slovenia
    'es', // [eur] spain
    'dk', // [dkk, pay in eur] denmark
    'pl', // [pln, pay in eur] poland
    'ro', // [ron, pay in eur] romania
    'se', // [sek, pay in eur] sweden
    'ch', // [chf, pay in eur] switzerland
  ];
}
